import UHCLogoIcon from '@src/Assets/images/uhcBrandmark.png';
import { AiIcon } from '@src/Assets/svg/AiIcon';
import { InfoIcon } from '@src/Assets/svg/InfoIcon';
import { OpenInNewIcon } from '@src/Assets/svg/OpenInNewIcon';
import KnowledgeCenterCallWrapper from '@src/CommonComponents/KnowledgeCenterCallWrapper/KnowledgeCenterCallWrapper';
import { APP_EVENTS } from '@src/constants/app-shell-constants';
import { StorageService } from '@src/utility/storage.service';
import React, { useEffect, useRef, useState } from 'react';
import {
  ActionBar,
  AiIconStyles,
  ContentWrapper,
  InsightsWrapper,
  KnowledgeCenterLink,
  LogoVector,
  MainNav,
  UHCInsightsLogoWrapper,
  UserInfo,
  UserInfoBlock,
  UtilityNav,
} from './Header.style';
import { HEADER_CONST } from './constants';
import { checkIsSimulationMode } from '@src/utility/createStorage';
export const Header = () => {
  const { INSIGHTS_TEXT, KNOWLEDGE_CENTER } = HEADER_CONST;

  const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '[]');
  const isMyHomeRoute = window.location.pathname.toLowerCase().includes('/myhome');

  const [userFirstName, setUserFirstName] = useState('');
  const [profileName, setProfileName] = useState('');
  const [optumId, setOptumId] = useState('');
  const [msId, setMsId] = useState('');
  const [emailId, setEmailId] = useState('');

  //checking internal or external user
  const isInternal = currentUser?.[0]?.UserPersonas?.[0]?.UserType === 'Internal';

  const [openDropdownBool, setOpenDropdownBool] = React.useState(false);
  const [suppressAiTooltip, setSuppressAiTooltip] = useState(false);
  const [isSimulationMode, setIsSimulationMode] = useState(checkIsSimulationMode());
  //useRef for Closing dropdown on outside click
  const userInfoRef = useRef<HTMLDivElement>(null);
  const storageService = new StorageService();

  useEffect(() => {
    const checkLoggedUser = () => {
      const loggedUser = sessionStorage.getItem('loggedUser');
      if (loggedUser) {
        const userData = JSON.parse(loggedUser);
        setEmailId(userData?.EmailId);
        setUserFirstName(userData?.FirstName);
        if (userData?.MsId) setMsId(userData.MsId);
        if (userData?.OptumId) setOptumId(userData.OptumId);
        setProfileName(userData?.FirstName + ' ' + userData?.LastName);
        return true;
      }
      return false;
    };

    const intref = setInterval(() => {
      if (checkLoggedUser()) {
        clearInterval(intref);
      }
    }, 100);

    const timeoutRef = setTimeout(() => {
      clearInterval(intref);
    }, 60000);

    return () => {
      clearInterval(intref);
      clearTimeout(timeoutRef);
    };
  }, []);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userInfoRef.current && !userInfoRef.current.contains(event.target as Node)) {
        setOpenDropdownBool(false);
      }
    };

    if (openDropdownBool) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdownBool]);

  // Listen for simulation mode changes
  useEffect(() => {
    const handleSimulationModeChange = () => {
      setIsSimulationMode(checkIsSimulationMode());
    };

    // Check for simulation mode changes periodically or via storage events
    window.addEventListener('storage', handleSimulationModeChange);

    // Also listen for custom events if simulation mode is toggled within the same tab
    const intervalId = setInterval(() => {
      const currentSimMode = checkIsSimulationMode();
      if (currentSimMode !== isSimulationMode) {
        setIsSimulationMode(currentSimMode);
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleSimulationModeChange);
      clearInterval(intervalId);
    };
  }, [isSimulationMode]);

  const onAIGenieClick = () => {
    const data = {
      interactionName: 'UHC AI Assistant Icon Click',
      interactionValue: 'AI Genie',
      interactionContext: 'header',
    };
    storageService.setAppEventDataLayerForAdobeOnInteraction(data);
    const currentUrl = window.location.pathname.toLowerCase();
    const isPsms = currentUrl.includes('psms');
    window.location.href = isPsms ? '/PSMS/pype-entity' : '/pype-entity';
  };
  const setAiTooltipSuppressed = (isSuppressed: boolean) => {
    setSuppressAiTooltip(isSuppressed);
  };

  const setHamburgerOverlayState = (isTooltipActive: boolean) => {
    window.dispatchEvent(
      new CustomEvent('dropdownStateChange', {
        detail: { value: isTooltipActive ? 1 : -1 },
      })
    );
  };
  const openResponsiveHamMenu = () => {
    window.dispatchEvent(new CustomEvent(APP_EVENTS.OPEN_RESPONSIVE_HAM_MENU));
  };
  // event handler for signout button
  const signoutButton = (event) => {
    event.stopPropagation();
    const data = {
      interactionName: 'header',
      interactionValue: 'Sign Out',
      interactionContext: 'header link click ',
    };
    storageService.setAppEventDataLayerForAdobeOnInteraction(data);
    window.dispatchEvent(new CustomEvent('signout'));
  };

  return (
    <>
      <MainNav>
        <ContentWrapper>
          {!isMyHomeRoute && (
            <button
              type="button"
              className="responsive-menu-icon"
              onClick={openResponsiveHamMenu}
              aria-label="Open navigation menu"
            >
              <span />
              <span />
              <span />
            </button>
          )}
          <UHCInsightsLogoWrapper>
            <LogoVector>
              <img className="Uhc-logo" src={UHCLogoIcon} alt="UHC Logo Icon" />
            </LogoVector>
            <div className="line_separator"></div>
            <InsightsWrapper>
              <div className="insights_text">{INSIGHTS_TEXT}</div>
            </InsightsWrapper>
          </UHCInsightsLogoWrapper>

          <ActionBar></ActionBar>
          <UtilityNav>
            {isInternal && !isSimulationMode && (
              <AiIconStyles>
                <button
                  type="button"
                  onClick={onAIGenieClick}
                  onMouseDown={() => setAiTooltipSuppressed(true)}
                  onTouchStart={() => setAiTooltipSuppressed(true)}
                  onMouseEnter={() => setHamburgerOverlayState(true)}
                  onMouseLeave={() => {
                    setHamburgerOverlayState(false);
                    setAiTooltipSuppressed(false);
                  }}
                  onFocus={() => setHamburgerOverlayState(true)}
                  onBlur={() => {
                    setHamburgerOverlayState(false);
                    setAiTooltipSuppressed(false);
                  }}
                  className={`help_icon_block ai_icon${
                    suppressAiTooltip ? ' tooltip-suppressed' : ''
                  }`}
                >
                  <span className="ai-tooltip ai-tooltip-multiline">
                    <span>UHC insights Assistant</span>
                    <span>Chat to explore UHC</span>
                    <span>Insights data.</span>
                  </span>
                  <div className="help-icon" aria-hidden="true">
                    <AiIcon />
                  </div>
                </button>
              </AiIconStyles>
            )}
            {KnowledgeCenterCallWrapper && (
              <KnowledgeCenterCallWrapper metricId="ALL" title="ALL">
                <KnowledgeCenterLink>
                  <div className="kc_text">{KNOWLEDGE_CENTER}</div>
                  <div className="open_in_new_icon">
                    <OpenInNewIcon />
                  </div>
                </KnowledgeCenterLink>
              </KnowledgeCenterCallWrapper>
            )}
            <UserInfo ref={userInfoRef} onClick={() => setOpenDropdownBool(!openDropdownBool)}>
              <div className="userinfo_icon">
                <InfoIcon />
              </div>
              <div className="userinfo_text">{userFirstName}</div>

              {openDropdownBool && (
                <UserInfoBlock>
                  <div className="profile-details-block">
                    <p className="profile-name">{profileName}</p>
                    <p className="profile-mail">{emailId}</p>
                    {!isInternal ? (
                      <p className="profile-id">One Healthcare ID: {optumId}</p>
                    ) : (
                      <p className="profile-id">MSID: {msId}</p>
                    )}
                  </div>
                  <div className="user-sectB">
                    <div className="signout">
                      <div className="signout-background" onClick={signoutButton}>
                        <div className="signout-btn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#757588"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            preserveAspectRatio="xMidYMid meet"
                            focusable="false"
                          >
                            <path d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"></path>
                          </svg>
                        </div>
                        <div className="signout-text" data-testid="signout-text">
                          Sign Out
                        </div>
                      </div>
                    </div>
                  </div>
                </UserInfoBlock>
              )}
            </UserInfo>
          </UtilityNav>
        </ContentWrapper>
      </MainNav>
    </>
  );
};
export default Header;
